import {
  type Credit,
  type CreditReason,
  creditReasonZod,
} from "@nlc/shared-types";
import { z } from "zod";

export const CREDIT_REASON_LABELS: Record<Credit["reason"], string> = {
  "billing-error": "Billing error",
  "customer-satisfaction": "Customer satisfaction",
  goodwill: "Goodwill",
  migration: "Migration",
  other: "Other",
  "plan-change": "Plan change",
  proration: "Proration",
  "qa-issue": "QA issue",
  "turnaround-delay": "Turnaround delay",
};

export const CREDIT_REASON_OPTIONS: { id: CreditReason; label: string }[] =
  creditReasonZod.options.map((id) => ({
    id,
    label: CREDIT_REASON_LABELS[id],
  }));

export const creditReasonFieldsSchema = {
  note: z.string().trim(),
  reason: z.enum(creditReasonZod.options, {
    errorMap: () => ({ message: "Select a reason" }),
  }),
};
